import { ChevronUp } from 'lucide-react';
import styled from 'styled-components';

export interface BannerContainerProps {
  $backgroundColor?: string;
  $borderColor?: string;
  $borderRadius?: string;
  $padding?: string;
  $margin?: string;
}

export const BannerContainer = styled.div<BannerContainerProps>`
  position: relative;
  border: 1px solid ${props => props.$borderColor || 'var(--color-planet-green)'};
  border-radius: ${props => props.$borderRadius || '0.75rem'};
  padding: ${props => props.$padding || '1.5rem'};
  margin: ${props => props.$margin || '0 0 1.5rem 0'};
  background-color: ${props => props.$backgroundColor || 'var(--color-planet-green-alpha20)'};
`;

export interface TitleBadgeProps {
  $badgeBackgroundColor?: string;
  $badgeTextColor?: string;
  $badgeBorderRadius?: string;
  $badgePosition?: { top?: string; left?: string; right?: string; bottom?: string };
  $badgePadding?: string;
  $badgeFontSize?: string;
}

export const TitleBadge = styled.span<TitleBadgeProps>`
  background: ${props => props.$badgeBackgroundColor || 'var(--color-planet-green)'};
  border-radius: ${props => props.$badgeBorderRadius || '0.5rem'};
  position: absolute;
  top: ${props => props.$badgePosition?.top || '-10px'};
  left: ${props => props.$badgePosition?.left || '-10px'};
  right: ${props => props.$badgePosition?.right || 'auto'};
  bottom: ${props => props.$badgePosition?.bottom || 'auto'};
  width: fit-content;
  height: fit-content;
  padding: ${props => props.$badgePadding || '0.25rem 0.75rem'};
  color: ${props => props.$badgeTextColor || 'var(--color-white)'};
  font-size: ${props => props.$badgeFontSize || '0.875rem'};
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
`;

export interface BannerContentProps {
  $isExpanded: boolean;
  $maxHeight?: string;
  $transitionDuration?: string;
}

export const BannerContent = styled.div<BannerContentProps>`
  overflow: hidden;
  transition: all ${props => props.$transitionDuration || '300ms'} ease-in-out;
  max-height: ${props => (props.$isExpanded ? (props.$maxHeight || '500px') : '0')};
  opacity: ${props => (props.$isExpanded ? '1' : '0')};
`;

export interface ToggleButtonProps {
  $buttonColor?: string;
  $buttonFontWeight?: string;
  $buttonGap?: string;
}

export const ToggleButton = styled.span<ToggleButtonProps>`
  display: flex;
  align-items: center;
  gap: ${props => props.$buttonGap || '0.2rem'};
  cursor: pointer;
  color: ${props => props.$buttonColor || 'var(--color-gray-800)'};
  font-weight: ${props => props.$buttonFontWeight || 'var(--font-weight-medium)'};
  user-select: none;
  
  &:hover {
    opacity: 0.8;
  }
`;

export interface StyledChevronProps {
  $isExpanded: boolean;
  $transitionDuration?: string;
  $iconSize?: number;
}

export const StyledChevron = styled(ChevronUp)<StyledChevronProps>`
  margin-top: 2px;
  transform: ${props => (props.$isExpanded ? 'rotate(0)' : 'rotate(180deg)')};
  transition: transform ${props => props.$transitionDuration || '300ms'};
`;